// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__25PpJ","subheader":"ReorderModal_subheader__1nte5","listWrap":"ReorderModal_listWrap__VfDCe"};